import { Modal } from '@mantine/core';
import type { FC } from 'react';
import React from 'react';
import { CompleteProfileForm } from '@/Module/Auth/Component';
import type { ICompleteProfileForm } from '@/Module/Auth/Model/DataModel';
// import HeaderBarWelcome from '@/Module/Auth/Component/HeaderBarWelcome/HeaderBarWelcome';

interface IProfileModalProps {
  isOpen: boolean;
  onSuccess: (payload: ICompleteProfileForm) => void;
}
const ProfileModal: FC<IProfileModalProps> = ({
  isOpen,
  onSuccess
}) => {
  return <Modal opened={isOpen} size="md" centered onClose={() => {}} overlayProps={{
    className: '',
    style: {
      backdropFilter: '#0e4791'
    },
    backgroundOpacity: 0.35,
    blur: 9
  }} withCloseButton={false} classNames={{
    root: 'bg-[rgba(14, 71, 145, 0.25)] ',
    content: 'shadow-theme shadow-blueFive bg-blueOne border-4 border-blueFive  py-3'
  }} data-sentry-element="Modal" data-sentry-component="ProfileModal" data-sentry-source-file="ProfileModal.tsx">
      {/* <HeaderBarWelcome step={1} /> */}
      <div className="my-2 text-xl font-extrabold text-blueFive">عضویت در آی‌نو</div>
      <div className="mb-8 text-sm text-blueFive">برای عضویت در آی‌نو فرم اطلاعاتت رو کامل کن</div>
      <CompleteProfileForm onSuccess={onSuccess} data-sentry-element="CompleteProfileForm" data-sentry-source-file="ProfileModal.tsx" />
    </Modal>;
};
export default ProfileModal;